// Main config export file
import API_CONFIG from './api.config';
import APP_CONFIG from './app.config';
import AUTH_CONFIG from './auth.config';
import ROUTES from './routes.config';
import STORAGE_KEYS from './storage.config';
import THEME from './theme.config';
import * as CONSTANTS from './constants';
import { SOCIALS, ORGANIZATION_SAME_AS } from './socials';
import { SITE_ORIGIN, SITE_NAME, absoluteUrl } from './site';

// Export all configuration
export {
  API_CONFIG,
  APP_CONFIG,
  AUTH_CONFIG,
  ROUTES,
  STORAGE_KEYS,
  THEME,
  CONSTANTS,
  SOCIALS,
  ORGANIZATION_SAME_AS,
  SITE_ORIGIN,
  SITE_NAME,
  absoluteUrl
};

// Default export
export default {
  API: API_CONFIG,
  APP: APP_CONFIG,
  AUTH: AUTH_CONFIG,
  ROUTES,
  STORAGE: STORAGE_KEYS,
  THEME,
  CONSTANTS,
  SOCIALS,
  ORGANIZATION_SAME_AS,
  SITE_ORIGIN,
  SITE_NAME,
  absoluteUrl
};
